import styled from 'styled-components';

export const LoaderWrap = styled.div`
  margin-left: auto;
  margin-right: auto;
`;
